import { FormControl, IconButton, InputAdornment, InputLabel, makeStyles, MenuItem, OutlinedInput, Select, useTheme } from "@material-ui/core";
import CancelIcon from '@material-ui/icons/Cancel';
import React from "react";
import PropTypes from 'prop-types'

const useStyles = makeStyles({
    cancelButton: {
        padding: "8px"
    },
    select: {
        paddingRight: "0px !important"
    }
})

function DropdownSelect(props) {

    const [labelWidth, setLabelWidth] = React.useState(0);

    const inputLabel = React.useRef(null);

    const classes = useStyles()

    React.useEffect(() => {
        setLabelWidth(inputLabel.current.offsetWidth);
    }, []);
    let value = (props.value !== null && props.value !== undefined) ? props.value : ""

    if (value === "" && props.multiple) {
        value = []
    }

    return (
        <FormControl disabled={props.disabled} variant="outlined" margin="dense" fullWidth error={props.error != null}>
            <InputLabel ref={inputLabel} className={classes.label}>
                {props.label}
            </InputLabel>

            <Select
                key="something araosj"
                classes={{ select: classes.select }}
                multiple={props.multiple}
                value={value}
                fullWidth
                onChange={(event) => props.handleChange(event.target.value)}
                input={
                    <OutlinedInput
                        labelWidth={labelWidth}
                        endAdornment={
                            props.compulsory || props.disabled || value === "" || value.length === 0 ?
                                null :
                                (
                                    <InputAdornment
                                        position="end" >
                                        <IconButton
                                            className={classes.cancelButton}
                                            onClick={(event) => {
                                                if (props.multiple) {
                                                    props.handleChange([])
                                                } else {
                                                    props.handleChange("")
                                                }
                                            }}
                                        >
                                            <CancelIcon />
                                        </IconButton>
                                    </InputAdornment>
                                )
                        }
                    />
                }
                autoWidth
            >
                {props.data.map(item => {
                    const disabledData = props.disabledData != null ? props.disabledData : []
                    const disabled = item == null ? false : disabledData.includes(item.key)
                    return (
                        <MenuItem disabled={disabled} key={item == null ? "None" : item.key != null ? item.key : item} value={item == null ? null : item.key != null ? item.key : item}>
                            {(item == null ? "None" : item.value != null ? item.value : item).toString()}
                        </MenuItem>
                    );
                })}
            </Select>
            {props.children}
        </FormControl >
    );
}

DropdownSelect.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    multiple: PropTypes.bool,
    disabled: PropTypes.bool,
    error: PropTypes.string,
    label: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
    data: PropTypes.array.isRequired,
    children: PropTypes.node,
    disabledData: PropTypes.arrayOf(PropTypes.string),
    compulsory: PropTypes.bool,
    valueName: PropTypes.string
}

export default DropdownSelect